/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFProcessPagedResponse } from './CRSFProcessPagedResponse';
import {
    CRSFProcessPagedResponseFromJSON,
    CRSFProcessPagedResponseFromJSONTyped,
    CRSFProcessPagedResponseToJSON,
} from './CRSFProcessPagedResponse';
import type { CRSFProcessShort } from './CRSFProcessShort';
import {
    CRSFProcessShortFromJSON,
    CRSFProcessShortFromJSONTyped,
    CRSFProcessShortToJSON,
} from './CRSFProcessShort';
import type { CRSFProcessShortPagedResponse } from './CRSFProcessShortPagedResponse';
import {
    CRSFProcessShortPagedResponseFromJSON,
    CRSFProcessShortPagedResponseFromJSONTyped,
    CRSFProcessShortPagedResponseToJSON,
} from './CRSFProcessShortPagedResponse';

/**
 * 
 * @export
 * @interface ResponseListLastListGet
 */
export interface ResponseListLastListGet {
    /**
     * 
     * @type {number}
     * @memberof ResponseListLastListGet
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseListLastListGet
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFProcessShort>}
     * @memberof ResponseListLastListGet
     */
    results?: Array<CRSFProcessShort>;
    /**
     * 
     * @type {number}
     * @memberof ResponseListLastListGet
     */
    total?: number;
}

/**
 * Check if a given object implements the ResponseListLastListGet interface.
 */
export function instanceOfResponseListLastListGet(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ResponseListLastListGetFromJSON(json: any): ResponseListLastListGet {
    return ResponseListLastListGetFromJSONTyped(json, false);
}

export function ResponseListLastListGetFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListLastListGet {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFProcessShortFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function ResponseListLastListGetToJSON(value?: ResponseListLastListGet | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFProcessShortToJSON)),
        'total': value.total,
    };
}

